import Dialog from '@skatteetaten/frontend-components/Dialog';

export const DialogKnapperad = ({ children }) => {
  return <Dialog.Footer>{children}</Dialog.Footer>;
};
